import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import macinstallericon from "../../../../assets/images/blogs/pp23/macinstallericon.png";
import * as React from 'react';
export default {
  ShortCutDisplay,
  PolypaneIntro,
  macinstallericon,
  React
};